exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__issuer-icon___14_m8{position:relative;z-index:10;display:flex;align-items:flex-start;flex-flow:row;justify-content:flex-end;box-sizing:border-box;width:100%;padding:1.5rem 1.5rem 0}.styles__issuer-icon___14_m8 img{width:20%}", ""]);

// exports
exports.locals = {
	"issuer-icon": "styles__issuer-icon___14_m8"
};